// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Created by Inzamam Janjua on 18/05/2023.
 */
.verfy-wrap {
  width: 100%;
  min-height: 100vh;
  display: flex;
  align-items: center;
  background: url('mesh-gradient.d2e368c6b9d92bb7.png') center center;
  background-size: cover;
  flex-direction: column;
}
.verfy-wrap .verfy-screen-logo {
  margin-top: 60px;
}
.verfy-wrap .verfy-box {
  background: #FFFFFF;
  border-radius: 20px;
  padding: 40px 94px;
  text-align: center;
  width: 1024px;
  margin-top: 60px;
  max-width: 90%;
}
.verfy-wrap .verfy-box h2 {
  font-style: normal;
  font-weight: 600;
  font-size: 32px;
  line-height: 30px;
  color: #0A6ED9;
  margin-bottom: 16px;
}
.verfy-wrap .verfy-box h3 {
  color: #0A6ED9;
  font-size: 22px;
  line-height: 20px;
  font-weight: 500;
  text-align: left;
}
.verfy-wrap .verfy-box p {
  font-style: normal;
  font-weight: 400;
  font-size: 24px;
  line-height: 30px;
  text-align: center;
  color: #000000;
}
.verfy-wrap .verfy-box .Verify-dob {
  border: 1px solid #D1D5DB;
  border-radius: 6px;
  background: #fff;
  display: flex;
  align-items: center;
  gap: 15px;
  margin-top: 40px;
  padding: 0 20px;
  height: 54px;
}
@media (max-width: 768px) {
  .verfy-wrap .verfy-box {
    padding: 40px 20px;
  }
  .verfy-wrap .verfy-box p {
    font-size: 16px;
    padding: 0 25px;
  }
}

.verify-agency-logo {
  max-width: 450px;
}

.powered-wrapper {
  margin-top: 60px;
  display: flex;
  gap: 4px;
  flex-direction: column;
}
.powered-wrapper span {
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  letter-spacing: -0.25px;
  color: #1F2937;
}
.powered-wrapper .image-wrapper {
  width: 168px;
}
.powered-wrapper .image-wrapper img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.status-indc {
  width: 100%;
  height: 45px;
  background-color: #6ACE6A;
  margin-right: 1px;
  margin-top: 15px;
}

.status-false {
  width: 100%;
  height: 45px;
  background-color: #FF3C3C;
  margin-right: 1px;
  margin-top: 15px;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/colors.scss","webpack://./src/app/ioh-status/ioh-status.component.scss"],"names":[],"mappings":"AAAA;;EAAA;ACCA;EACI,WAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,mEAAA;EACA,sBAAA;EACA,sBAAA;AAGJ;AAFI;EACI,gBAAA;AAIR;AAFI;EACI,mBAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,gBAAA;EACA,cAAA;AAIR;AAHQ;EACI,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cDlBE;ECmBF,mBAAA;AAKZ;AAHQ;EACI,cDtBE;ECuBF,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;AAKZ;AAHQ;EACI,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;AAKZ;AAHQ;EACI,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;EACA,eAAA;EACA,YAAA;AAKZ;AAHQ;EA1CJ;IA2CQ,kBAAA;EAMV;EALU;IACI,eAAA;IACA,eAAA;EAOd;AACF;;AAHA;EACI,gBAAA;AAMJ;;AAJA;EACI,gBAAA;EACA,aAAA;EACA,QAAA;EACA,sBAAA;AAOJ;AANI;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,cAAA;AAQR;AANI;EACI,YAAA;AAQR;AAPQ;EACI,WAAA;EACA,YAAA;EACA,mBAAA;AASZ;;AAJA;EACI,WAAA;EACA,YAAA;EACA,yBD/EI;ECgFJ,iBAAA;EACA,gBAAA;AAOJ;;AAJA;EACI,WAAA;EACA,YAAA;EACA,yBD/EO;ECgFP,iBAAA;EACA,gBAAA;AAOJ","sourcesContent":["/**\n * Created by Inzamam Janjua on 18/05/2023.\n */\n\n\n// Primary Color Palette\n\n$primaryBlue: #0A6ED9;\n$GreenBlue: #1C75BC;\n$Orange: #EF896A;\n$DarkSilver: #6C6D70;\n$BrightYellow: #F9A51D;\n$Green: #6ACE6A;\n$Greenlight: #7AEC7A;\n$GreenDark: #5CB85C;\n$white: #fff;\n$black: #000;\n$red:#C66A9E;\n// Standard System Colors\n\n$errorRed: #FF3C3C;\n$darkRed: #C11574;\n$lightRed: #FDF2FA;\n$successGreen: #10B981;\n$lightGreen: #ECFAF5;\n$lightOrange: #FFF2EB;\n$notificationYellow: #F9A51D;\n$lightBlue:rgba(226, 238, 255, 1);\n$headingText: #1E38A9;\n","@import \"../../assets/styles/colors.scss\";\n.verfy-wrap{\n    width: 100%;\n    min-height: 100vh;\n    display: flex;\n    align-items: center;\n    background:url(../../assets/images/mesh-gradient.png) center center;\n    background-size: cover;\n    flex-direction: column;\n    .verfy-screen-logo{\n        margin-top:60px;\n    }\n    .verfy-box{\n        background: #FFFFFF;\n        border-radius: 20px;\n        padding: 40px 94px;\n        text-align: center;\n        width: 1024px;\n        margin-top: 60px;\n        max-width:90%;\n        h2{\n            font-style: normal;\n            font-weight: 600;\n            font-size: 32px;\n            line-height: 30px;\n            color: $primaryBlue;\n            margin-bottom: 16px;\n        }\n        h3{\n            color: $primaryBlue;\n            font-size: 22px;\n            line-height: 20px;\n            font-weight: 500;\n            text-align: left;\n        }\n        p{\n            font-style: normal;\n            font-weight: 400;\n            font-size: 24px;\n            line-height: 30px;\n            text-align: center;\n            color: #000000;\n        }\n        .Verify-dob{\n            border: 1px solid #D1D5DB;\n            border-radius: 6px;\n            background: #fff;\n            display: flex;\n            align-items: center;\n            gap: 15px;\n            margin-top: 40px;\n            padding:0 20px;\n            height: 54px;\n        }\n        @media(max-width:768px){\n            padding:40px 20px;\n            p{\n                font-size: 16px;\n                padding: 0 25px;\n            }\n        }\n    }\n}\n.verify-agency-logo{\n    max-width: 450px;\n}\n.powered-wrapper {\n    margin-top: 60px;\n    display: flex;\n    gap: 4px;\n    flex-direction: column;\n    span {\n        font-size: 12px;\n        font-weight: 500;\n        line-height: 16px;\n        letter-spacing: -0.25px;\n        color: #1F2937;\n    }\n    .image-wrapper {\n        width: 168px;\n        img {\n            width: 100%;\n            height: 100%;\n            object-fit: contain;\n        }\n    }\n\n}\n.status-indc{\n    width: 100%;\n    height: 45px;\n    background-color: $Green;\n    margin-right: 1px;\n    margin-top: 15px;\n}\n\n.status-false{\n    width: 100%;\n    height: 45px;\n    background-color: $errorRed;\n    margin-right: 1px;\n    margin-top: 15px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
